export default __webpack_public_path__ + "static/shai-reznik-c8db5eaa3e91f5bdfb4df2bbe7609032.jpg";